module.exports = __webpack_public_path__ + "img/404xsmall.7b89961f.png";